/* Sveto trojstvo — motion: reveal on scroll, hero intro, auto-tag reveal targets */
(function () {
  document.documentElement.classList.add('st-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tagTargets() {
    var sel = [
      '.st-section__head', '.st-step', '.st-usage__media', '.st-usage__body', '.st-manifest__inner',
      '.card-wrapper', '.collapsible-content .accordion', '.st-ig .page-width > *', '.footer-block'
    ];
    document.querySelectorAll(sel.join(',')).forEach(function (el, i) {
      if (el.classList.contains('st-reveal')) return;
      el.classList.add('st-reveal');
      var parent = el.parentElement;
      if (parent) {
        var idx = Array.prototype.indexOf.call(parent.children, el);
        if (idx > 0 && idx < 5) el.classList.add('st-reveal--d' + idx);
      }
    });
  }

  function reveal() {
    var els = document.querySelectorAll('.st-reveal');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { document.querySelectorAll('.st-reveal:not(.is-in)').forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight) e.classList.add('is-in'); }); }, 2500);
  }

  function hero() {
    var h = document.querySelector('.st-hero');
    if (!h) return;
    requestAnimationFrame(function () { setTimeout(function () { h.classList.add('is-loaded'); }, 80); });
    if (reduce) return;
    var img = h.querySelector('.st-hero__bg img');
    if (!img) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        if (y < window.innerHeight * 1.2) img.style.translate = '0 ' + (y * 0.18) + 'px';
        ticking = false;
      });
    }, { passive: true });
  }

  function init() { tagTargets(); reveal(); hero(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { tagTargets(); reveal(); });
})();
